import '../Assessments/index.scss';
import * as Icons from '@carbon/icons-react';
import { Step5Props } from '../../../lib/interfaces';
import {
  CodeSnippetSkeleton,
  SkeletonPlaceholder,
  SkeletonText,
} from 'carbon-components-react';
import { toJpeg } from 'html-to-image';
import { useEffect } from 'react';
import { imageToBase64 } from 'src/apps/solution-advisor/lib/helpers';

const Step5 = ({
  productObj,
  setBase64Image3,
  productUrl,
  loadInline,
  useTranslation,
}: Step5Props) => {
  const _triggerSnapshot = async () => {
    await imageToBase64(productUrl || '', true).then((base64String) => {
      setBase64Image3?.(base64String);
    });
  };

  useEffect(() => {
    if (productUrl && loadInline) {
      setTimeout(() => _triggerSnapshot(), 10);
    }
  }, [productUrl, loadInline]);

  return (
    <>
      <div className="bx--row ">
        <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16 page_body_2">
          <div className="padding_8 padding_24_2">
            {useTranslation('step5_para', true)}
          </div>
          {productObj && productObj.offname ? (
            <h3>{productObj.offname}</h3>
          ) : (
            <SkeletonText width="70%" />
          )}
        </div>
        <div className="bx--col-lg-10 bx--col-md-4 bx--col-sm-16 page_body_2">
          <div className="padding_8 p-t-16">
            {productObj?.features && !!productObj.features.length ? (
              productObj.features.map((f, i) => {
                const iconName = f.icon || 'CheckmarkOutline16';
                type IconName = keyof typeof Icons;
                const NewIcon = Icons[iconName as IconName];
                if (!NewIcon) {
                  console.error(`Icon "${iconName}" not found in Icons.`);
                  return null;
                }
                return (
                  <div className="bx--row m-b-1" key={i}>
                    <div className="bx--col-sm-4 bx--col-md-8 bx--col-lg-16 product-desc">
                      <NewIcon color="green" />
                      <div className="bx--form-item">{f.label}</div>
                    </div>
                  </div>
                );
              })
            ) : (
              <CodeSnippetSkeleton type="multi" />
            )}
          </div>
          {productObj && productObj.offprice ? (
            <>
              <div className="slide_text">
                {useTranslation('step5_price', true)}
              </div>
              <div className="page_sub_heading">{productObj.offprice}</div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="bx--col-lg-6 bx--col-md-4 bx--col-sm-16">
          <div className="padding_8 p-t-16">
            {productUrl ? (
              <img
                src={productUrl}
                width="100%"
                height="100%"
                id="graphSummary"
                alt="product-image"
                className="steps screen"
                style={{ width: '100%' }}
              />
            ) : (
              <SkeletonPlaceholder className="skeleton-image" />
            )}
          </div>
        </div>
        <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16 page_body_2">
          <div className="slide_text bx--col-padding">
            {useTranslation(
              productObj && productObj.offprice
                ? 'step5_summary1_price'
                : 'step5_summary1',
            )}
          </div>
          <div className="slide_text bx--col-padding">
            {useTranslation('step5_summary2', true)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Step5;
